import type { Ref } from 'vue'
import { unref } from 'vue'

export const isDefinedRef = <T>(
  _ref: Ref<T | undefined | null>
): _ref is Ref<T> => unref(_ref) !== undefined && unref(_ref) !== null
